const LOCATION_CHANGED = "locationChanged";

export { LOCATION_CHANGED };
